import { render, staticRenderFns } from "./ProgramPreview.vue?vue&type=template&id=0d462d00&scoped=true"
import script from "./ProgramPreview.vue?vue&type=script&lang=js"
export * from "./ProgramPreview.vue?vue&type=script&lang=js"
import style0 from "./ProgramPreview.vue?vue&type=style&index=0&id=0d462d00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d462d00",
  null
  
)

export default component.exports